import { ILocationSpaceItem } from "@/types/api/Locations";

const separateSpaceBySpaceAssetType = (spaces: ILocationSpaceItem[]) => {
  if (!spaces) {
    return {
      activationSpaces: [],
      mediaOpportunitySpaces: []
    };
  }

  const activationSpaces: ILocationSpaceItem[] = [];
  const mediaOpportunitySpaces: ILocationSpaceItem[] = [];

  spaces.forEach((space) => {
    switch (space.spaceAssetType) {
      case "media_opportunity":
        mediaOpportunitySpaces.push(space);
        break;
      case "activation":
      default:
        activationSpaces.push(space);
        break;
    }
  });

  return {
    activationSpaces,
    mediaOpportunitySpaces
  }
}

export default separateSpaceBySpaceAssetType;
